import { Save } from '@mui/icons-material'
import { Button, SxProps, Theme, Typography, useTheme } from '@mui/material'
import { ComponentProps } from 'react'

import getButtonStyles, {
  BUTTON_TEXT_STYLES,
} from '~/components/createEdit/utils'
import rem from '~/utils/ui'

type TProps = { label: string; shortLabel?: string } & Omit<
  ComponentProps<typeof Button>,
  'children'
>

function SaveButton({ label, shortLabel = '', sx, ...props }: TProps) {
  const theme = useTheme()

  return (
    <Button
      startIcon={<Save />}
      sx={
        {
          ...getButtonStyles(theme),
          ...sx,
        } as SxProps<Theme>
      }
      {...props}
    >
      <Typography variant="h4" sx={BUTTON_TEXT_STYLES}>
        {label}
      </Typography>
      <Typography
        variant="h4"
        sx={{
          fontSize: rem(12),
          fontWeight: 700,
          display: {
            xxxs: 'block',
            md: 'none',
          },
        }}
      >
        {shortLabel || label}
      </Typography>
    </Button>
  )
}

export default SaveButton
